<ng-content></ng-content>
<span [style.color]="color">{{ title }}</span>
<span [style.color]="color">{{ content }}</span>
